@import 'node_modules/@oebb-web-team/oebb-web-library/src/css/accessibility';
@import 'src/global/variables';

:host {
    display: inline-block;
}

.infobox-container {
    .infobox-handle {
		display: block;
        color: inherit;
        background: transparent;
        border: none;
        padding: 0;
        min-height: 1.5rem;
        min-width: 1.5rem;
    }

    .infobox-icon {
        cursor: pointer;

        svg {
			display: inline-block;
            position: relative;
            top: 3px;
            height: 1em;
            width: 1em;
        }
    }

	.infobox-item-square {
		color: $colour-grey-information-icon;
	}
}
